import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoadingComponent } from './common/components/loading/loading.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { BreadcrumbComponent } from './common/components/breadcrumb/breadcrumb.component';
import { AuthService } from './common/services/auth/auth.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Language, LanguageResponse, LanguageSubjectModel } from './common/components/language-switcher/language-switcher.model';
import { PageService } from './common/services/page/page.service';
import { CacheService } from './common/services/cache.service';
import { CACHE_KEYS } from './common/constants/cache-keys';
import { LanguageSwitcherService } from './common/components/language-switcher/language-switcher.service';
import { getBrowserLanguage } from './common/util/utils';
import { DOCUMENT } from '@angular/common';
import { GtmService } from './common/services/gtm/gtm.service';
import { LoginService } from './login/login.service';

@Component({
  selector: 'nuc-root',
  imports: [LoadingComponent, RouterOutlet, BreadcrumbComponent, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'nuc-portal';

  showHeader: boolean = false;
  showFooter: boolean = false;
  showBreadCrumb: boolean = false;
  currentPagePath: string;
  authoredLanguages: Language[];
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private authService: AuthService, private overlayContainer: OverlayContainer, private pageService: PageService, private cacheService: CacheService,
    private languageService: LanguageSwitcherService, private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private gtmService: GtmService, private loginService: LoginService) { }

  ngOnInit(): void {
    const accessToken = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.ACCESS_TOKEN);
    if (accessToken) {
      this.fetchUserRoles();
    }

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.activatedRoute;
        while (currentRoute?.firstChild) {
          currentRoute = currentRoute?.firstChild;
        }
        const routeData = currentRoute.snapshot.data;
        this.currentPagePath = currentRoute.snapshot.routeConfig?.path || '';
        // Default to true, but override if data is defined
        this.showHeader = !(routeData['hideHeader'] ?? false);
        this.showFooter = !(routeData['hideFooter'] ?? false);
        window.scrollTo(0, 0);
        this.setInitialLanguage(routeData);              
      });

    this.overlayContainer.getContainerElement().classList.add('nuc-overlay-container');
  }

  private fetchUserRoles(): void {
    this.loginService.getLpmiUserRoles().subscribe({
      error: (err) => {
        console.error('Error fetching user roles:', err);
      },
    });
  }

  setInitialLanguage(routeData:any): void {
    this.languageService.getLanguages().subscribe((data: LanguageResponse) => {
      this.authoredLanguages = data.results;
      this.cacheService.addToCache(CACHE_KEYS.LOGIN.AUTHORED_LANGUAGES, this.authoredLanguages);
      let prefLanguage: Language = this.pageService.getPreferredLanguage();
      const defaultLang: Language = { countryCode: 'US', languageCode: 'en' };
      let langModel: LanguageSubjectModel = { "status": "true", "authoredLanguages": this.authoredLanguages };
      let lang: Language;
      if (this.currentPagePath == "login") {
        lang = getBrowserLanguage();
        let haslangInAuthoredList = this.authoredLanguages?.find(x => x.languageCode?.toLowerCase() == lang?.languageCode?.toLowerCase());
        lang = haslangInAuthoredList ? lang : defaultLang;
        this.cacheService.addToCache(CACHE_KEYS.LOGIN.LANGUAGE, lang);
        this.languageService.setLanguageStatus(langModel);
      }
      else {
        let haslangInAuthoredList = this.authoredLanguages?.find(x => x.languageCode?.toLowerCase() == prefLanguage?.languageCode?.toLowerCase());
        lang = haslangInAuthoredList ? prefLanguage : defaultLang;
        this.cacheService.addToCache(CACHE_KEYS.LOGIN.LANGUAGE, lang);
      }

      //push dataLayer variables for gtm
      let loginSelections = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_SELECTIONS);
      if(routeData['pageCategory']){
        this.gtmService.pushPageDataEvent(lang, routeData['subCategory'], routeData['pageCategory'], routeData['pagePath'], loginSelections?.selectedBusinessLabel?.value);
      }
    });
  }

}
